import React from "react";
import { TrendUpIcon } from "./AnalyticsIcons";

const AnalyticsStatCard = ({ label, value, icon, trend, iconBg }) => {
  return (
    <div className="v2-analytics-pg-stat">
      <div className="v2-analytics-pg-stat__content">
        <span className="v2-analytics-pg-stat__label">{label}</span>
        <span className="v2-analytics-pg-stat__value">{value}</span>
        <div className="v2-analytics-pg-stat__trend">
          <TrendUpIcon size={14} color="#22c55e" />
          <span className="v2-analytics-pg-stat__trend-text">{trend}</span>
        </div>
      </div>
      <div
        className="v2-analytics-pg-stat__icon"
        style={{ backgroundColor: iconBg || "#fef2f2" }}
      >
        {icon}
      </div>
    </div>
  );
};

export default AnalyticsStatCard;
